import LocationCitySearchResourcePagingResultModel from '../../generated/types/model/resource/LocationCitySearchResourcePagingResultModel';

export default class LocationCitySearchResourcePagingResultViewModel extends LocationCitySearchResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
